import { apiClient } from 'pobble-components/dist/api'

const apiUnassignParent = data =>
  apiClient.post('v3/parentships/unassign', data)

export { apiUnassignParent }
